import { Component, ElementRef, Input, OnInit, Output, ViewChild, EventEmitter, SimpleChanges, OnChanges, } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { MultiSelectorDetails } from 'src/app/model/multi-selector-details';
import { ReceivingChannelFilters } from 'src/app/model/receiving-channel-filter';
import { messages } from 'src/app/resources/messages';
import { CatalogService } from 'src/app/services/catalog.service';

@Component({
  selector: 'receiving-channel-dropdown',
  templateUrl: './receiving-channel-dropdown.component.html',
  styleUrls: ['./receiving-channel-dropdown.component.scss']
})
export class ReceivingChannelDropdownComponent implements OnInit, OnChanges {

  @Input() isOptional: boolean = true;
  @Input() displayLabel!: string;
  @Input() allowMultiSelect: boolean = true;
  @Input() selectorControlName!: AbstractControl<string>;
  @Input() submitted!: string;
  @Input() ariaText: string = 'Receiving channel drop down';
  @Input() moduleType!: string;
  @Input() filter: ReceivingChannelFilters = ReceivingChannelDropdownComponent.filterDefaults;
  @Input() dataPreLoadRequired: boolean = true;
  @Input() withoutCash: boolean = false;
  @Output() selectedValues = new EventEmitter<string[]>();

  @ViewChild('receivingChannelReference') receivingChannelRef: ElementRef | undefined;

  public msg = messages;
  public paymentModesList: MultiSelectorDetails[] = [];
  public maxSelectionCount: number | undefined;
  public componentId!: string;
  public defaultStatus: any;
  public static readonly filterDefaults: ReceivingChannelFilters = {
    CountryId: '',
    CityId: -1,
    CurrencyId: ''
  };
  public paymentModeListWithAllData : any[] = [];

  constructor(private catalogService: CatalogService) { }

  ngOnInit(): void {
    this.setId();
    if (this.dataPreLoadRequired){
      this.getPaymentModesData();
    }
    this.setMaxlimit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    for (const property in changes) {
      if (changes.hasOwnProperty(property) && !changes[property].firstChange) {
        if (property === "filter") {
          this.getPaymentModesData();
        }
      }
    }
  }

  getPaymentModesData() {
    if (this.withoutCash) {
      this.catalogService.getActiveModeOfPaymentsWithoutCash().subscribe(response => {
        this.paymentModesList = response.data
          .map(x => <MultiSelectorDetails><unknown>{
            id: x.paymentModeId,
            description: [x.paymentModeName]
          });
      })
    }
    else if (JSON.stringify(this.filter) === JSON.stringify(ReceivingChannelDropdownComponent.filterDefaults)) {
      this.catalogService.getModeOfPayments().subscribe(response => {
        this.paymentModeListWithAllData = response.data.filter(x => x.status === 'A');
        this.paymentModesList = response.data.filter(x => x.status === 'A')
          .map(x => <MultiSelectorDetails><unknown>{
            id: x.paymentModeId,
            description: [x.paymentModeName]
          });
      })
    }
    else {
      this.catalogService.getModeOfPaymentsByFilter(this.filter).subscribe(response => {
        this.paymentModeListWithAllData = response.data;
        this.paymentModesList = response.data
          .map(x => <MultiSelectorDetails><unknown>{
            id: x.paymentModeId,
            description: [x.paymentModeName]
          });
      })
    }
  }

  public setSelectedReceivingChannel($event: any) {
    let receivingChannel: string[] = $event.detail?.selectedItemArray.map(
      (x: MultiSelectorDetails) => x.id
    );
    this.selectedValues.emit(receivingChannel);
    if (this.maxSelectionCount === 1) {
      this.receivingChannelRef?.nativeElement.closeSelectionPanel();
    }
  }

  private setMaxlimit() {
    if (this.allowMultiSelect) {
      this.maxSelectionCount = undefined;
    } else {
      this.maxSelectionCount = 1;
    }
  }

  private setId() {
    if (!this.displayLabel) {
      this.componentId = 'Receiving channel';
    } else {
      this.componentId = this.displayLabel.replace(' ', '-');
    }
  }

  public reset() {
    this.receivingChannelRef?.nativeElement.resetSelectMenu();
  }
}
